


import React, {useEffect , ReactNode } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import LoginScreen from "./pages/LoginScreen";
import PatientListScreen from "./pages/PatientListScreen";
import Header from "./components/layout/Header";
import DentalChartingScreen from "./pages/DentalChartingScreen";
import PediatricAssessmentScreen from "./pages/PediatricAssessmentScreen";
import DermatologyScreen from "./pages/DermatologyScreen";

import OnboardingLanding from "./auth/pages/OnboardingLanding";
import OnboardingPhone from "./auth/pages/OnboardingPhone";
import OnboardingPassword from "./auth/pages/OnboardingPassword";
import OnboardingProfile from "./auth/pages/OnboardingProfile";
import OnboardingSuccess from "./auth/pages/OnboardingSuccess";
import NoRoleAssigned from "./pages/NoRoleAssigned";
import PrivateRoute from "./routes/PrivateRoute";
import PediatricFinalReviewScreen from "./pages/PediatricFinalReviewScreen";

const MainLayout = ({ children }: { children: ReactNode }) => (
  <div>
    <Header />
    <main>{children}</main>
  </div>
);

const Unauthorized = () => (
  <div style={{ padding: 40 }}>
    <h2>Unauthorized</h2>
    <p>You don’t have permission to access this page.</p>
  </div>
);

// Queue page
const RoleQueuePage = () => {
  const { roleKey } = useParams<{ roleKey: string }>();

  return (
    <MainLayout>
      <PatientListScreen />
      <div style={{ padding: "0 40px", fontSize: 12, color: "#666" }}>
        Active queue roleKey: <b>{roleKey}</b>
      </div>
    </MainLayout>
  );
};

function App() {

useEffect(() => {

  const disableContextMenu = (e: MouseEvent) => {
    e.preventDefault();
  };

  document.addEventListener(
    "contextmenu",
    disableContextMenu
  );

  return () => {
    document.removeEventListener(
      "contextmenu",
      disableContextMenu
    );
  };

}, []);

  return (
    <Router>
      <Routes>
        {/* Login */}
        <Route path="/" element={<LoginScreen />} />
        <Route path="/no-role" element={<NoRoleAssigned />} />

        {/* Unauthorized */}
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Generic patients fallback */}
        <Route
          path="/patients"
          element={
            <PrivateRoute>
              <MainLayout>
                <PatientListScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        {/* Queue (role validated inside screen if needed) */}
        <Route
          path="/queue/:roleKey"
          element={
            <PrivateRoute>
              <RoleQueuePage />
            </PrivateRoute>
          }
        />

        {/* ✅ TELE_DENTIST */}
        <Route
          path="/patient/:emrNumber/charting"
          element={
            <PrivateRoute requiredRoleKeys={["TELE_DENTIST"]}>
              <MainLayout>
                <DentalChartingScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        {/* ✅ PEDIATRIC */}
        <Route
          path="/patient/:emrNumber/pediatric-assessment"
          element={
            <PrivateRoute requiredRoleKeys={["PEDIATRIC_RESIDENT"]}>
              <MainLayout>
                <PediatricAssessmentScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

        {/* ✅ DERMATOLOGY */}
        <Route
          path="/patient/:emrNumber/dermatology-assessment"
          element={
            <PrivateRoute requiredRoleKeys={["DERMATOLOGY"]}>
              <MainLayout>
                <DermatologyScreen />
              </MainLayout>
            </PrivateRoute>
          }
        />

 <Route
 path="/patient/:emrNumber/final-review"
 element={
   <PrivateRoute>
      <MainLayout>
         <PediatricFinalReviewScreen />
      </MainLayout>
   </PrivateRoute>
 }
/>


        {/* Onboarding */}
        <Route path="/onboarding" element={<OnboardingLanding />} />
        <Route path="/onboarding/phone" element={<OnboardingPhone />} />
        <Route path="/onboarding/password" element={<OnboardingPassword />} />
        <Route path="/onboarding/profile" element={<OnboardingProfile />} />
        <Route path="/onboarding/success" element={<OnboardingSuccess />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
